import React, { FC, useCallback, useContext } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext';
import { IBasicOrganization } from '../resources/models/IOrganization';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { ChooseOrganization } from '../components/ChooseOrganization/ChooseOrganization';
import Dialog from '@mui/material/Dialog';
import { apiUser } from '../resources/api/apiUser';
import { AuthContext } from '../contexts/AuthContext';
import { useApiErrorHandler } from '../hooks/useApiErrorHandler';
import { CurrentUserContext } from '../contexts/CurrentUserContext';

const { useUpdateDefaultOrganization } = apiUser;

export const ChooseOrganizationPage: FC = () => {
  const { t } = useTranslation();
  const { identity } = useContext(AuthContext);
  const handleError = useApiErrorHandler();

  const { logOut } = useAuth();

  const { refetchUserInfo } = useContext(CurrentUserContext);
  const { setOrganization } = useContext(OrganizationContext);
  const { execute: setDefaultOrganization } = useUpdateDefaultOrganization(identity?.userId);

  const onSubmit = useCallback(
    async (organization: IBasicOrganization, setDefault: boolean) => {
      try {
        setOrganization(organization);
        if (setDefault) {
          await setDefaultOrganization(organization);
          await refetchUserInfo();
        }
      } catch (e) {
        handleError(e);
      }
    },
    [setOrganization, setDefaultOrganization]
  );

  const noOrgAction = useCallback(() => {
    setOrganization(null);
  }, [setOrganization]);

  return (
    <Dialog open={!!identity}>
      <ChooseOrganization
        cancelAction={logOut}
        submitAction={onSubmit}
        cancelText={t('chooseOrganization.logOutButton')}
        submitText={t('chooseOrganization.signInButton')}
        noOrgText={t('chooseOrganization.skipOrganization')}
        noOrgAction={noOrgAction}
      />
    </Dialog>
  );
};
